export default "img[data-v-3b7f0582]{width:auto;height:auto}"